module.exports = __webpack_public_path__ + "nc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/nc.svg
// module id = 723
// module chunks = 0